export class Contact {
  first_name: string;
  last_name: string;
  message: string;
  phone: string;
  email: string;
  property_id: number;
  marketing_accepted: boolean;
}
